import React from 'react';
// TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!

import { useLoomTouchpointWithProjectType } from '@jira/issue__loom-videos/src/use-loom-touchpoint-with-project-type/index.tsx';
// eslint-disable-next-line jira/restricted/@atlaskit+analytics-next
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { LoomTouchpointVariant } from '@atlassian/jira-loom-utils/src/controllers/use-loom-touchpoint-variant/types.tsx';
import { LoomRecorderLoadingBlanket } from '@atlassian/jira-loom-utils/src/ui/loom-recorder-loading-blanket/index.tsx';
import { LoomCoUsePanel } from './co-use/index.tsx';

// Loom panel that launched with M2.5
export const LoomPanel = (): React.JSX.Element | null => {
	const { loomTouchpointVariant } = useLoomTouchpointWithProjectType();
	if (loomTouchpointVariant === LoomTouchpointVariant.NONE) {
		return null;
	}
	return (
		<AnalyticsContext
			data={{
				attributes: {
					loomTouchpointVariant,
				},
			}}
		>
			<LoomCoUsePanel />
			<LoomRecorderLoadingBlanket />
		</AnalyticsContext>
	);
};
